/**
 * @fileoverview PUT handler for the "/companies/:company_id/notification_preferences/bulk_add" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdNotificationPreferencesBulkAddCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdNotificationPreferencesBulkAddProps,
  CompaniesCompanyIdNotificationPreferencesBulkAddResult,
} from "./types";

export const putCompaniesCompanyIdNotificationPreferencesBulkAdd = reactQueryMutationAdapter(
  companiesCompanyIdNotificationPreferencesBulkAddCacheKeys,
  (
    props: PutCompaniesCompanyIdNotificationPreferencesBulkAddProps
  ): Promise<CompaniesCompanyIdNotificationPreferencesBulkAddResult> => {
    return fetch(`/companies/${props.company_id}/notification_preferences/bulk_add`, "PUT", props);
  }
);
